// @ts-nocheck
import * as React from "react";

const Refresh: React.FC = () => {
    return (
        /* Store Custom Code - Start */
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                d="M12.076 19c-1.954 0-3.61-.678-4.966-2.034-1.356-1.355-2.034-3.01-2.034-4.963 0-1.953.678-3.609 2.034-4.966C8.467 5.678 10.122 5 12.076 5c1.188 0 2.301.282 3.339.847a6.699 6.699 0 0 1 2.507 2.364V5h1v5.23h-5.23v-1h3.7a5.937 5.937 0 0 0-2.198-2.363A5.857 5.857 0 0 0 12.076 6c-1.667 0-3.083.583-4.25 1.75-1.166 1.167-1.75 2.583-1.75 4.25 0 1.667.584 3.083 1.75 4.25C8.993 17.417 10.41 18 12.076 18a5.863 5.863 0 0 0 3.475-1.1 5.81 5.81 0 0 0 2.175-2.9h1.062c-.441 1.498-1.28 2.705-2.514 3.623C15.04 18.541 13.64 19 12.076 19Z"
            />
        </svg>
        /* Store Custom Code - End */
    );
};

export default React.memo(Refresh);
